import TripleColumnContainer from '../../../Layout/Containers/TripleColumnContainer';
import styles from './solutionCards.module.scss';
import { StrapiImageComponent } from '../../MediaComponent/MediaComponent';
import Link from 'next/link';
import React from 'react';

const SolutionCards = ({ solutions }: any) => {
    if (!solutions) {
        return null;
    }
    return (
        <TripleColumnContainer extraClassNames={styles.solutionsContainer} largeContainer={true}>
            {solutions.map((solution: any) => {
                return (
                    <div className={styles.solutionContainer} key={`solution-${solution.heading}`}>
                        <StrapiImageComponent
                            className={styles.solutionImage}
                            maxWidth={1644}
                            maxHeight={924}
                            strapiImage={solution.image}
                        >
                            <div className={styles.overlay}></div>
                        </StrapiImageComponent>
                        <div className={styles.solutionInformation}>
                            <h2>{solution.heading}</h2>
                            <p>{solution.description}</p>
                            <Link
                                href={solution.link}
                                title={`Go to ${solution.heading}} solution for more information`}
                            >
                                <span>Read more &#10132;</span>
                            </Link>
                        </div>
                    </div>
                );
            })}
        </TripleColumnContainer>
    );
};

export default SolutionCards;
